import React from 'react';
import DataGridSection from 'PDF/TemplateEngine/sections/DataGridSection';
import TextSection from 'PDF/TemplateEngine/sections/TextSection';
import TableSection from 'PDF/TemplateEngine/sections/TableSection';
import ImagesSection from 'PDF/TemplateEngine/sections/ImagesSection';
import SignaturesSection from 'PDF/TemplateEngine/sections/SignaturesSection';
import RichTextSection from 'PDF/TemplateEngine/sections/RichTextSection';
import MetaGridSection from 'PDF/TemplateEngine/sections/MetaGridSection';
import TitleBandSection from 'PDF/TemplateEngine/sections/TitleBandSection';
import StatStripSection from 'PDF/TemplateEngine/sections/StatStripSection';
import InspectionMatrixSection from 'PDF/TemplateEngine/sections/InspectionMatrixSection';
import InspectionPerEquipmentSection from 'PDF/TemplateEngine/sections/InspectionPerEquipmentSection';
import IncidenceSummarySection from 'PDF/TemplateEngine/sections/IncidenceSummarySection';
import ChecklistSection from 'PDF/TemplateEngine/sections/ChecklistSection';
import HeaderSection from 'PDF/TemplateEngine/sections/HeaderSection';
import FooterSection from 'PDF/TemplateEngine/sections/FooterSection';
import PortraitSection from 'PDF/TemplateEngine/sections/PortraitSection';
import { evaluateVisibleIf } from 'PDF/TemplateEngine/utils/evaluateVisibleIf';

// Body sections: las que viven dentro del <View body> de cada página. Los
// types 'portrait', 'header' y 'footer' son posicionales y el TemplateRenderer
// los extrae del sections[] antes de entrar acá; no se renderizan en el body.
const BODY_COMPONENT_BY_TYPE = {
  'data-grid': DataGridSection,
  text: TextSection,
  'text-rich': RichTextSection,
  'meta-grid': MetaGridSection,
  table: TableSection,
  images: ImagesSection,
  signatures: SignaturesSection,
  'title-band': TitleBandSection,
  'stat-strip': StatStripSection,
  'inspection-matrix': InspectionMatrixSection,
  'inspection-per-equipment': InspectionPerEquipmentSection,
  'incidence-summary': IncidenceSummarySection,
  checklist: ChecklistSection,
};

// Types posicionales (no body). Se exportan para que los layouts externos
// (TemplateRenderer, renderTemplateBody, editor) puedan filtrarlos.
export const POSITIONAL_SECTION_TYPES = ['portrait', 'header', 'footer'];

// Componentes por type para los positional — consumidos por el dispatcher del
// TemplateRenderer.
export const POSITIONAL_COMPONENT_BY_TYPE = {
  portrait: PortraitSection,
  header: HeaderSection,
  footer: FooterSection,
};

function SectionRenderer({ section, data, config }) {
  if (!section || section.visible === false) return null;
  if (section.visibleIf) {
    try {
      if (!evaluateVisibleIf(section.visibleIf, { data, config })) return null;
    } catch {
      return null;
    }
  }
  const Component = BODY_COMPONENT_BY_TYPE[section.type];
  if (!Component) return null;
  return <Component section={section} data={data} config={config} />;
}

export default SectionRenderer;
